<template>
  <div>
    <b-modal
      id="modalConfiguracaoCaixaPostal"
      ref="modalConfiguracaoCaixaPostal"
      no-close-on-backdrop
      header-class="pb-0"
      @hidden="fechar"
    >
      <template #modal-title>
        <h5 class="mb-0">
          Configurações Caixa Postal
        </h5>
        <small class="text-muted">Nessa tela será possível configurar a visualização das mensagens na plataforma</small>
      </template>

      <hr class="mt-0 mb-1">

      <div class="d-flex align-items-center mb-75">
        <span style="font-size: 0.80rem; font-weight: 600; text-transform: uppercase; color: #5e5873; letter-spacing: 0.02em;">
          DESTACAR MENSAGENS NÃO LIDAS NA PLATAFORMA
        </span>
        <feather-icon
          v-b-tooltip.hover="{ title: 'Ao habilitar esta função, todas as novas mensagens do e-CAC serão importadas para a plataforma Monitor Contábil e ficarão destacadas em negrito até serem lidas na plataforma.', customClass: 'tooltip-dark-config' }"
          icon="InfoIcon"
          size="15"
          class="ml-50"
          style="color: #b9b9c3; cursor: pointer;"
        />
      </div>

      <b-form-checkbox
        v-model="config.destacarMensagensNaoLidas"
        switch
      >
        Negrito
      </b-form-checkbox>

      <div class="mt-1">
        <b-btn
          variant="none"
          class="btn-none text-primary p-0"
          style="font-size: 0.85rem;"
          @click="abrirHistorico"
        >
          <font-awesome-icon
            icon="fa-sharp fa-solid fa-list"
            class="mr-50"
          />
          Log
        </b-btn>
      </div>

      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <b-btn
            variant="none"
            size="sm"
            class="btn-outline-success btn-none mr-1"
            @click="salvar"
          >
            Salvar
          </b-btn>
          <b-btn
            variant="none"
            size="sm"
            class="btn-outline-danger btn-none"
            @click="fechar"
          >
            Cancelar
          </b-btn>
        </div>
      </template>
    </b-modal>

    <historico-configuracao-caixa-postal
      ref="modalHistorico"
    />
  </div>
</template>

<style lang="scss">
#modalConfiguracaoCaixaPostal {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: center !important;

  .modal-dialog {
    width: 750px;
    max-width: 750px;
  }
}

.tooltip-dark-config .tooltip-inner {
  background-color: #000;
  color: #fff;
  border-radius: 6px;
  font-size: 0.78rem;
  max-width: 280px;
  text-align: left;
}
.tooltip-dark-config .arrow::before {
  border-top-color: #000;
}
</style>

<script>
import api from '../../services/api'

export default {
  name: 'ConfiguracaoCaixaPostal',
  components: {
    HistoricoConfiguracaoCaixaPostal: () => import('./HistoricoConfiguracaoCaixaPostal.vue'),
  },
  data() {
    return {
      configOriginal: { destacarMensagensNaoLidas: true },
      config: { destacarMensagensNaoLidas: true },
    }
  },
  methods: {
    show() {
      api.getConfiguracao()
        .then(response => {
          const dados = response.data || {}
          this.config = { destacarMensagensNaoLidas: dados.destacarMensagensNaoLidas !== false }
          this.configOriginal = { ...this.config }
        })
        .catch(() => {
          this.config = { destacarMensagensNaoLidas: true }
          this.configOriginal = { ...this.config }
        })
        .finally(() => {
          this.$refs.modalConfiguracaoCaixaPostal.show()
        })
    },
    salvar() {
      api.salvarConfiguracao(this.config)
        .then(() => {
          this.$sucesso('Configuração salva com sucesso!')
          this.configOriginal = { ...this.config }
          this.$refs.modalConfiguracaoCaixaPostal.hide()
          this.$emit('salvo')
        })
        .catch(err => {
          this.$erro('Não foi possível salvar a configuração.')
          throw err
        })
    },
    fechar() {
      this.config = { ...this.configOriginal }
      this.$refs.modalConfiguracaoCaixaPostal.hide()
    },
    abrirHistorico() {
      this.$refs.modalHistorico.show()
    },
  },
}
</script>
